
import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";

const titles = [
  { path: "/", title: "IndUS Tech | U.S.-India Commercial Strategy" },
  { path: "/what-we-do", title: "What We Do | IndUS Tech" },
  { path: "/Insights", title: "Insights | IndUS Tech" },
  { path: "/About", title: "About | IndUS Tech" },
  { path: "/contact-us", title: "Contact | IndUS Tech" },
  { path: "/privacy-policy", title: "Privacy Policy | IndUS Tech" },
  { path: "/terms-condition", title: "Terms & Conditions | IndUS Tech" },
];

const DEFAULT_TITLE = "IndUS Tech | U.S.-India Commercial Strategy";

export default function TitleManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const match = titles.find(({ path }) =>
      matchPath({ path, end: true }, pathname)
    );
    document.title = match ? match.title : DEFAULT_TITLE;
  }, [pathname]);

  return null;
}